import type { CSSProperties } from 'react';

// ProRef wordmark — no icon. Family, weight and casing come from the --wm-* tokens
// (Stadium renders it as an uppercase heavy grotesk lockup).
interface LogoProps {
  // Font size in px for the wordmark text.
  size?: number;
  // Override colour for both syllables (e.g. on the dark login panel). Defaults to ink + accent.
  color?: string;
  className?: string;
}

export function Logo({ size = 16, color, className }: LogoProps) {
  const wrap: CSSProperties = {
    fontFamily: 'var(--wm-family)',
    letterSpacing: 'var(--wm-tracking)',
    textTransform: 'var(--wm-transform)' as CSSProperties['textTransform'],
    gap: 'var(--wm-gap)',
    fontSize: size,
    color: color ?? 'var(--ink)',
  };
  return (
    <span className={'inline-flex items-baseline leading-none ' + (className ?? '')} style={wrap}>
      <span style={{ fontWeight: 'var(--wm-pro-weight)' as CSSProperties['fontWeight'] }}>Pro</span>
      <span
        style={{
          fontWeight: 'var(--wm-ref-weight)' as CSSProperties['fontWeight'],
          color: color ?? 'var(--accent)',
        }}
      >
        Ref
      </span>
    </span>
  );
}
